<template>
  <section v-if="pageLoader">
    <div class="page-loader">Загрузка...</div>
  </section>
  <section v-else-if="!userIsEmpty('user')" class="tests">
    <div class="tests-wrapper">
      <h1 class="heading"><div class="container-mobile">Тесты</div></h1>
      <div class="tabs container-mobile">
        <div
          v-for="(tab, key) in tabs"
          @click="toggleTabs(tabs, key, updateTabObserver(key, tabs))"
          class="tabs-item"
          :key="key"
          :class="{ 'tabs-current': tab.selected }"
        >
          {{ tab.text }}
        </div>
      </div>
      <div v-if="tabs.premium.selected" class="info-block container-mobile">
        <ul v-if="!testsIsEmpty('premium', 'tests')" class="tests-list">
          <li
            v-for="(test, index) in testsPremium"
            class="tests-item"
            :ref="'premium' + index"
            :key="test.id"
          >
            <div class="tests-avatar">
              <div
                :style="{
                  'background-image': test.avatar
                    ? 'url(' + test.avatar + ')'
                    : '',
                }"
                class="tests-avatar-inner"
                :class="{ 'no-image': !test.avatar }"
              ></div>
            </div>
            <div class="tests-body">
              <div class="tests-name">{{ test.title }}</div>
              <div class="tests-description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis
                ipsum suspendisse ultrices gravida. Risus commodo viverra
                maecenas accumsan lacus vel facilisis.
              </div>
              <div v-if="test.bought_id" class="tests-bottom">
                <redirectButton
                  pathname="test"
                  :params="{ id: test.bought_id }"
                  html="Пройти тест"
                  class="button button-short"
                ></redirectButton>
                <div class="tests-bought">Тест куплен</div>
              </div>
              <div
                v-else-if="!initIsEmpty('init') && init.costs"
                class="tests-bottom"
              >
                <button
                  @click="buy(test.id, vipPrice(test.price), 'premium' + index)"
                  class="button"
                  :id="'premium' + index"
                >
                  Купить и пройти тест
                </button>
                <div class="tests-price">{{ vipPrice(test.price) }}</div>
              </div>
            </div>
          </li>
          <li>
            <button v-if="moreLoader" class="button-loader"></button>
          </li>
        </ul>
        <div v-else class="tests-list">Список премиальных тестов пуст.</div>
      </div>
      <div v-if="tabs.free.selected" class="info-block">
        <ul v-if="!testsIsEmpty('free', 'tests')" class="tests-list">
          <li
            v-for="(test, index) in testsFree"
            :ref="'free' + index"
            :key="test.id"
            class="tests-item"
          >
            <div
              :style="{
                'background-image': test.avatar
                  ? 'url(' + test.avatar + ')'
                  : '',
              }"
              class="tests-avatar"
              :class="{ 'no-image': !test.avatar }"
            ></div>
            <div class="tests-body">
              <div class="tests-name">{{ test.title }}</div>
              <div class="tests-description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis
                ipsum suspendisse ultrices gravida. Risus commodo viverra
                maecenas accumsan lacus vel facilisis.
              </div>
              <div class="tests-bottom">
                <redirectButton
                  v-if="test.bought_id"
                  pathname="test"
                  :params="{ id: test.bought_id }"
                  html="Пройти тест"
                  class="button button-short"
                ></redirectButton>
                <button
                  v-else
                  @click="buy(test.id, 0, 'free' + index)"
                  class="button button-short"
                  :id="'free' + index"
                >
                  Пройти тест
                </button>
              </div>
            </div>
          </li>
          <li>
            <button v-if="moreLoader" class="button-loader"></button>
          </li>
        </ul>
        <div v-else class="tests-list">Список бесплатных тестов пуст.</div>
      </div>
    </div>
  </section>
  <section v-else class="no-auth">
    Вы не авторизованы! Пожалуйста,
    <router-link class="link" tag="a" :to="{ name: 'home' }"
      >войдите или зарегистрируйтесь</router-link
    >
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import redirectButton from "@/components/Buttons/Redirect";
import { toggleTabs } from "@/mixins/toggleTabs";
import { observeListEnd } from "@/mixins/observeListEnd";

export default {
  name: "Tests",
  components: {
    redirectButton,
  },
  mixins: [toggleTabs, observeListEnd],
  data() {
    return {
      pageLoader: true,
      moreLoader: false,
      tabs: {
        premium: {
          text: "Премиальные",
          selected: true,
          moreIndex: 0,
          observer: null,
          data: "testsPremium",
          next: "testsPremiumNext",
        },
        free: {
          text: "Бесплатные",
          selected: false,
          moreIndex: 0,
          observer: null,
          data: "testsFree",
          next: "testsFreeNext",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      userIsEmpty: "user/isEmpty",
      user: "user/fetchUser",
      userErrors: "user/errors",
      testsFree: "tests/fetchTestsFree",
      testsPremium: "tests/fetchTestsPremium",
      testsFreeNext: "tests/fetchTestsFreeNext",
      testsPremiumNext: "tests/fetchTestsPremiumNext",
      testsIsEmpty: "tests/isEmpty",
      boughtId: "tests/fetchBoughtId",
      init: "init/fetchInit",
      initIsEmpty: "init/isEmpty",
    }),
    vipPrice() {
      return (price) =>
        this.user.vip
          ? Math.ceil((price * (100 - this.init.costs.vip_discount)) / 100)
          : this.formatPrice(price);
    },
  },
  created() {
    this.getTests();
  },
  methods: {
    getTests() {
      let arr = [];
      for (let tab in this.tabs) {
        let self = this;

        this.tabs[tab].observer = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting === true && self.tabs[tab].selected) {
              self.showMore(tab);
            }
          },
          { threshold: [0] }
        );

        arr.push(
          this.$store.dispatch("tests/get", tab).then(() => {
            this.updateMoreIndex(tab);
            this.observeListEnd(tab, this.tabs);
          })
        );
      }
      Promise.all(arr)
        .then(() => {
          this.pageLoader = false;
        })
        .catch(() => {
          this.pageLoader = false;
        });
    },
    updateMoreIndex(tab) {
      this.tabs[tab].moreIndex = this[this.tabs[tab].data].length - 2;
    },
    showMore(tab) {
      if (this[this.tabs[tab].next]) {
        this.moreLoader = true;
        this.$store
          .dispatch("tests/getNext", tab)
          .then(() => {
            this.observeListEnd(tab, this.tabs, true, true);
            this.moreLoader = false;
          })
          .catch(() => {
            this.moreLoader = false;
          });
      } else {
        this.observeListEnd(tab, this.tabs, true);
      }
    },
    buy(id, price, elId) {
      if (parseFloat(this.user.balance) < parseFloat(price)) {
        this.$modal.show("dialog", {
          title: "Недостаточно средств",
          text: "Не хватает средств для покупки данного теста.",
          buttons: [
            {
              title: "Пополнить баланс",
              handler: () => {
                this.$modal.hide("dialog");
                this.$modal.show("balance-in");
              },
            },
            {
              title: "Закрыть",
            },
          ],
        });
      } else {
        // TODO: заменить на дочерние компоненты
        document.getElementById(elId).classList.add("button-loader");
        this.$store
          .dispatch("tests/buy", id)
          .then(() => {
            document.getElementById(elId).classList.remove("button-loader");
            this.$router.push({ name: "test", params: { id: this.boughtId } });
          })
          .catch(() => {
            document.getElementById(elId).classList.remove("button-loader");
          });
      }
    },
    formatPrice(price) {
      let arr = price.split(".");
      return arr[1] == "00" ? arr[0] : price;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_tabs";
@import "~@/assets/styles/pages/_tests";
</style>
